import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

import { UserContextProvider } from "context/UserContext";
import { GetProductsAPI } from "network/productAPI";
import { GetDataSet } from "network/wineDataSetAPI";
import { GetBeverages } from "network/beverages";

// Nome della sezione -> codice (il vino ha piu' nomi nei dati vecchi).
const WINE_NAMES = ["wine", "vino", "vini"];
const BEVERAGE_CODES = ["beer", "beverages", "waters", "drinks", "spirits", "mixers"];
const sectionCode = (name) => {
  const n = (name || "").trim().toLowerCase();
  return WINE_NAMES.includes(n) ? "wine" : n;
};

// Numero mostrato in una card. Admin: totale del catalogo (Wine Data e Dataset Bevande).
// Ristorante: prodotti inseriti nelle sue carte. null = niente da contare (es. Food per l'admin).
const fetchCount = async (section, isAdmin) => {
  if (isAdmin) {
    const code = sectionCode(section.name);
    if (code === "wine") {
      const res = await GetDataSet(1, 1);
      return res?.success ? res.data?.total_count ?? 0 : null;
    }
    if (BEVERAGE_CODES.includes(code)) {
      const res = await GetBeverages(1, 1, code);
      return res?.success ? res.data?.total_count ?? 0 : null;
    }
    return null;
  }
  const res = await GetProductsAPI(section.uuid, 1, 1);
  return res?.success
    ? res.data?.total_count ?? res.data?.products?.length ?? 0
    : null;
};

const Dashboard = () => {
  const { t } = useTranslation("dashboard");
  const { sections, user } = useContext(UserContextProvider);
  const [counts, setCounts] = useState({});
  // Il login restituisce "super_admin" per l'account principale (nel database e' "admin").
  const isAdmin = ["admin", "super_admin"].includes(
    user?.role?.toLowerCase()?.trim()
  );

  useEffect(() => {
    // Il ruolo decide cosa contare: si aspetta che l'utente sia caricato.
    if (!Array.isArray(sections) || !user) return;
    let active = true;
    setCounts({});
    sections.forEach(async (section) => {
      try {
        const total = await fetchCount(section, isAdmin);
        if (active) {
          setCounts((prev) => ({
            ...prev,
            [section.uuid]: total === null ? "—" : total,
          }));
        }
      } catch (error) {
        // se una sezione non risponde, il numero resta vuoto
      }
    });
    return () => {
      active = false;
    };
  }, [sections, user, isAdmin]);

  const list = Array.isArray(sections) ? sections : [];
  const total = Object.values(counts).reduce(
    (a, b) => a + (typeof b === "number" ? b : 0),
    0
  );

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <p className="card-category mb-4">
            {user?.restaurant_name || ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col lg="3" md="6">
          <Card className="card-stats">
            <CardBody>
              <p className="card-category">
                {isAdmin ? t("catalogItems") : t("totalProducts")}
              </p>
              <h3 className="card-title">{total}</h3>
            </CardBody>
          </Card>
        </Col>
        {list.map((section) => (
          <Col lg="3" md="6" key={section.uuid}>
            <Link to={`/${section.name?.toLowerCase()}/products`}>
              <Card className="card-stats">
                <CardBody>
                  <p className="card-category">{section.name}</p>
                  <h3 className="card-title">
                    {counts[section.uuid] ?? "…"}
                  </h3>
                </CardBody>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Dashboard;
